function ProductPromoBanner({ type, amount, collectionName = '' }) {
  return (
    <div class="flex flex-col gap-1 mt-6 px-5 pb-4 bg-[#457C9F] rounded-lg">
      {type === 'applied' ? (
        <>
          <div class="pt-3 font-semibold text-white">
            {translate.product.promoDiscountAppliedTitle.replace('{{ amount }}', amount)}
          </div>
          <div class="text-white text-xs">{translate.product.promoDiscountAppliedDescription}</div>
        </>
      ) : (
        <div class="pt-4 text-white text-sm">
          {translate.product.promoDiscountRelatedDescription.replace('{{ amount }}', amount).replace('{{ collection }}', collectionName)}
        </div>
      )}
    </div>
  )
}

export default ProductPromoBanner
